import { cn } from '#app/utils/misc.tsx'
import { ResponsiveMarketingImage } from './ResponsiveMarketingImage'

export interface FeatureSplitProps {
	title?: string
	subtitle?: string
	items: {
		title: string
		description: string
		image: {
			url: string
			alt?: string
		}
		imagePosition?: 'left' | 'right'
	}[]
}

export function FeatureSplit({ title, subtitle, items }: FeatureSplitProps) {
	return (
		<section className="bg-background py-16 md:py-20">
			<div className="container mx-auto flex max-w-5xl flex-col gap-12 px-6">
				{(title || subtitle) && (
					<header className="flex flex-col gap-5 text-left">
						{subtitle && (
							<span className="text-label text-muted-foreground">
								{subtitle}
							</span>
						)}
						{title && <h2 className="text-title-2 text-foreground">{title}</h2>}
					</header>
				)}

				<div className="space-y-12">
					{items.map((item, index) => (
						<article key={index} className="pt-8 md:pt-10">
							<div className="grid gap-8 md:grid-cols-5 md:gap-10">
								<div
									className={cn(
										'flex flex-col gap-4 md:col-span-3',
										item.imagePosition === 'left' && 'md:order-2',
									)}
								>
									<h3 className="text-title-2 text-foreground mb-4">
										{item.title}
									</h3>
									<div className="text-muted-foreground space-y-4 text-base whitespace-pre-line md:text-lg">
										{item.description}
									</div>
								</div>
								<div
									className={cn(
										'md:col-span-2',
										item.imagePosition === 'left' && 'md:order-1',
										item.imagePosition === 'right' && 'md:order-2',
									)}
								>
									<ResponsiveMarketingImage
										src={item.image.url}
										alt={item.image.alt || item.title}
										className="border-border h-full w-full rounded-2xl border object-cover"
										width={1200}
										height={900}
										sizes="(min-width: 768px) 40vw, 100vw"
									/>
								</div>
							</div>
						</article>
					))}
				</div>
			</div>
		</section>
	)
}
